import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ShippingCostType, ShippingProfileDialog } from '@client/components/listingForm/ShippingProfileDialog';
import { ProfileSelect } from '@client/components/listingForm/ProfileSelect';
import { useApiClient } from '@client/hooks/useApiClient';
import { toastError } from '@client/toaster';
import { callApi } from '@client/utils/apiUtils';
import { useState } from 'react';
export const ShippingProfileSelect = ({ shopShortId, profiles, onAddProfile, value, onChange, disabled, }) => {
    const apiClient = useApiClient();
    const [dialogOpen, setDialogOpen] = useState(false);
    const [saving, setSaving] = useState(false);
    return (_jsxs(_Fragment, { children: [_jsx(ProfileSelect, { items: profiles.map((p) => ({
                    value: String(p.id),
                    label: p.name,
                })), value: value, onChange: onChange, onClickAdd: () => setDialogOpen(true), disabled: disabled }), _jsx(ShippingProfileDialog, { open: dialogOpen, onClose: () => setDialogOpen(false), existingNames: profiles.map((p) => p.name), saving: saving, onConfirm: async (p) => {
                    setSaving(true);
                    const flatRate = p.cost.type === ShippingCostType.FlatRate ? p.cost.cents : null;
                    const result = await callApi(apiClient.shopManager.createShippingProfile({
                        params: { shopId: shopShortId },
                        body: {
                            name: p.name,
                            originZip: p.originZip,
                            flatShippingRateCents: flatRate,
                            shippingDaysMin: p.minDays,
                            shippingDaysMax: p.maxDays,
                        },
                    }));
                    setSaving(false);
                    if (result.error !== null) {
                        toastError('Failed to create shipping profile.');
                        return;
                    }
                    const profile = {
                        id: String(result.data.id),
                        name: result.data.name,
                        originZip: result.data.originZip,
                        cost: result.data.flatShippingRateCents != null
                            ? { type: ShippingCostType.FlatRate, cents: result.data.flatShippingRateCents }
                            : { type: ShippingCostType.Free },
                        minDays: result.data.shippingDaysMin,
                        maxDays: result.data.shippingDaysMax,
                    };
                    onAddProfile(profile);
                    onChange(profile.id);
                    setDialogOpen(false);
                } })] }));
};
